import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import themeColors from "../../constants/themeColors";

const TRUNCATE_AT = 200;

export default function Detail({ label, value, href, highlighted, removed, children, ...props }) {
	const { t } = useTranslation();

	const [expanded, setExpanded] = useState(false);

	const truncated = !expanded && typeof value === "string" && value.length > TRUNCATE_AT;
	const text = truncated ? `${value.slice(0, TRUNCATE_AT)}…` : value;

	return (
		<div {...props}>
			<p
				style={{
					opacity: highlighted || removed ? 1 : 0.4,
					fontSize: "0.9em",
					marginBottom: "0.1em",
					color: removed ? themeColors.RED : highlighted ? themeColors.GREEN : null,
				}}
			>
				{label}
			</p>

			{value ? (
				<div style={{ whiteSpace: "pre-wrap" }}>
					{href ? <Link to={href}>{text}</Link> : text}

					{(truncated || expanded) && (
						<span
							onClick={() => setExpanded((expanded) => !expanded)}
							style={{ marginLeft: "0.3em", color: "grey", fontSize: "0.85em", cursor: "pointer" }}
						>
							{expanded ? t("showLess", "Show less") : t("showMore", "Show more")}
						</span>
					)}
				</div>
			) : (
				children
			)}
		</div>
	);
}
